/**
 * Shared Systems-Integrations Store
 *
 * Store namespace path (`integrations/*` commands) is preserved.
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState, selectors } from './state';
import { handlers } from './handlers';
import { createConnectorListLoadPolicy } from './policies';

const store = createStore({
  name: 'systems-integrations',
  initialState,
  handlers
});

export const {
  useSelector: useSystemsIntegrationsSelector,
  useErrors: useSystemsIntegrationsErrors,
  useDispatch: useSystemsIntegrationsDispatch,
  usePolicies: useSystemsIntegrationsPolicies,
  getState: getSystemsIntegrationsState,
  dispatch: dispatchSystemsIntegrationsCommand
} = store;

/**
 * Policy factory - creates policies that require backend.
 */
export const createSystemsIntegrationsPolicies = ( backend: ClientLibraryType ) => [
  createConnectorListLoadPolicy( backend )
];

/**
 * Backward-compatible aliases for the pre-rename `Shared*` names.
 * Kept so the channels/erps subdomains keep compiling during the rename
 * window; new code should use the `SystemsIntegrations*` exports.
 */
export {
  useSystemsIntegrationsSelector as useSharedIntegrationsSelector,
  useSystemsIntegrationsErrors as useSharedIntegrationsErrors,
  useSystemsIntegrationsDispatch as useSharedIntegrationsDispatch,
  useSystemsIntegrationsPolicies as useSharedIntegrationsPolicies,
  getSystemsIntegrationsState as getSharedIntegrationsState,
  dispatchSystemsIntegrationsCommand as dispatchSharedIntegrationsCommand,
  createSystemsIntegrationsPolicies as createSharedIntegrationsPolicies
};

export { selectors };
